export default __webpack_public_path__ + "static/media/withdrawal-ico.73a6fb02.webp";